import React from "react";
import PropTypes from "prop-types";

import css from './FeatureLandingPageHeader.module.scss';

import logo from 'assets/feature-article-logo-color.svg';

import FeatureImageHeaderContent from "components/FeatureImageHeaderContent";
import MediaWrapper from "components/MediaWrapper";

const FeatureLandingPageHeader = ({ media, content, logoAltText }) => {
    return (
        <div className={css.featureLandingPageHeader}>
            <div className={css.logo}>
                <img alt={logoAltText} src={logo} />
            </div>
            <MediaWrapper
                media={media}
                gradient={MediaWrapper.gradients.feature}
                theme={MediaWrapper.themes.roundedCorners}
                isLandingPage
            >
                <FeatureImageHeaderContent isLandingPage {...content} />
            </MediaWrapper>
        </div>
    );
};

FeatureLandingPageHeader.propTypes = {
    media: PropTypes.shape({ isSticky: PropTypes.bool }),
    content: PropTypes.object,
    logoAltText: PropTypes.string
};

export default FeatureLandingPageHeader;



// WEBPACK FOOTER //
// ./src/components/FeatureLandingPageHeader/FeatureLandingPageHeader.jsx